// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__WJb17","name":"style_name__N0fb3","item":"style_item__DmdRS"};